// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Group, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput, PasswordInput, Checkbox } from '@/components/ui/inputs';
import { IconUser, IconMail, IconLock, IconArrowLeft } from '@tabler/icons-react';
import { AuthLayoutWrapper, SocialLoginButtons, PasswordStrength } from '../components';

export default function RegisterHeroImage() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Register attempt:', { name, email, password });
  };

  return (
    <AuthLayoutWrapper
      variant="cover"
      backgroundImage="https://images.unsplash.com/photo-1618005182384-a83a8bd57fbe?w=1920&q=80"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/register"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 52,
                height: 52,
                borderRadius: 14,
                background: 'linear-gradient(135deg, #f472b6, #c084fc)',
              }}
            >
              <Text size="xl" fw={700} c="white">R</Text>
            </Center>
            <Title order={2} ta="center">Get started</Title>
            <Text c="dimmed" size="sm" ta="center">
              Create your account now
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Name"
              placeholder="Your name"
              leftSection={<IconUser size={16} />}
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
            />

            <TextInput
              label="Email"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />

            <div>
              <PasswordInput
                label="Password"
                placeholder="Create a password"
                leftSection={<IconLock size={16} />}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
              {password && <PasswordStrength password={password} variant="bar" />}
            </div>

            <Checkbox
              label={
                <Text size="sm">
                  I agree to the <Anchor size="sm">Terms</Anchor>
                </Text>
              }
              checked={acceptTerms}
              onChange={(e) => setAcceptTerms(e.currentTarget.checked)}
            />

            <Button
              type="submit"
              fullWidth
              variant="gradient"
              gradient={{ from: 'pink', to: 'grape' }}
            >
              Sign up
            </Button>
          </Stack>
        </form>

        {/* Social Login */}
        <SocialLoginButtons
          providers={['google', 'apple']}
          layout="icons-only"
        />

        {/* Login Link */}
        <Text ta="center" size="sm">
          Have an account?{' '}
          <Anchor component={Link} to="/app/demo/auth-pages/login/cover" fw={500}>
            Sign in
          </Anchor>
        </Text>
      </Stack>
    </AuthLayoutWrapper>
  );
}
